import workspaceQuery from '../../queries/sales/CarrierWorkspaceQuery.graphql';
import listQuery from '../../queries/sales/CarrierListQuery.graphql';
import instanceQuery from '../../queries/sales/CarrierQuery.graphql';
import defaultQuery from '../../queries/sales/CarrierDefault.graphql';
import mutationQuery from '../../mutations/sales/CarrierMutation.graphql';
import fragment from '../../fragments/sales/CarrierFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Carrier: EntityType = {
  type: 'Carrier',
  title: 'Carriers',
  formTitle: 'Carrier',
  formUrl: '/Sales/Carrier/Details/',
  workspaceUrl: '/Sales/Carrier/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_CARRIERS',
};

export default Carrier;
